<template>
  <div>
    <slot name="label">
      <h2 class="mb-0">{{ $t('personalizedWalletCard.customize.color.label') }}</h2>
    </slot>
    <b-row class="mt-2 mx-0" align-h="start">
      <b-col class="py-1 px-0 d-flex flex-wrap justify-content-start">
        <b-button
          v-for="(color, index) in options"
          :key="index"
          :ref="color"
          class="color-selector mr-1 mb-2 d-flex justify-content-center align-items-center"
          :style="`background-color: ${color}`"
          :class="{ selected: selectedColor === color }"
          :title="colorNames[color]"
          :aria-label="`Choose ${colorNames[color]}`"
          @focus="setFocus(color)"
          @focusout="unsetFocus"
          @click="selectColor(color)"
        >
          <span v-show="selectedColor === color" :class="checkmarkColor">&check;</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { KeyboardNavigationMixins } from '@/mixins/keyboardNavigation';
export default {
  name: 'WalletCardColorSelect',
  mixins: [KeyboardNavigationMixins],
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedColor: null,
    };
  },
  computed: {
    checkmarkColor() {
      return this.selectedColor === '#f3b143' || this.selectedColor === '#51a855' ? 'text-black' : 'text-white';
    },
    navigableOptions() {
      return this.options;
    },
    colorNames() {
      return {
        '#0295db': 'Light Blue',
        '#dc30c3': 'Pink',
        '#51a855': 'Green',
        '#f3b143': 'Yellow',
        '#dc6028': 'Red',
        '#003566': 'Dark Blue',
      };
    },
  },
  created() {
    if (!this.selectedColor && this.options.length >= 1) {
      this.selectColor(this.options[0]);
    }
  },
  methods: {
    selectColor(color) {
      this.selectedColor = color;
      this.$emit('selectedColor', this.selectedColor);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.color-selector {
  width: 70px;
  height: 70px;
  @media (min-width: 992px) {
    width: 77px;
    height: 77px;
  }
  border: 2px solid $dp-white;
  cursor: pointer;
  span {
    font-size: 30px;
  }
}
.text-black {
  color: $dp-black;
}
</style>
